import { render, staticRenderFns } from "./BreakAndSort.vue?vue&type=template&id=9dca52de&scoped=true&"
import script from "./BreakAndSort.vue?vue&type=script&lang=js&"
export * from "./BreakAndSort.vue?vue&type=script&lang=js&"
import style0 from "./BreakAndSort.vue?vue&type=style&index=0&id=9dca52de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dca52de",
  null
  
)

export default component.exports